import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link, useNavigate  } from 'react-router-dom';
import DatePicker from 'react-date-picker';
import { searchQuery } from '../../actions/global-actions';
import { createTask } from '../../actions/tasks-actions';

function CreateTask(){
    const currentLink = "/tareas";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user.user);

    const [form, setForm] = useState({
        legalCaseID: '',
        legalCaseText: '',
        task: '',
        personInCharge: '',
        personInChargeText: '',
        date: '',
    });

    const [dropdown, setDropdown] = useState({
        show: false,
        value: '',
        data: []
    })

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleDateChange = ( name, date ) => {
        setForm({
            ...form,
            [name] :  date
        })
    }

    const handleSearchChange = (option, event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
        if (event.target.value.length > 2) {
            if (option === 1) {
                let param = { filingNumber: event.target.value }
                dispatch( searchQuery( event.target.id, param, searchFunction, user.token ) );
                return;
            }
            dispatch( searchQuery( event.target.id, event.target.value, searchFunction, user.token ) );
        } else {
            setDropdown({ show: false, value: '', data: [] });
        }
    }

    const searchFunction = ( link, data ) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //console.log(data);
            setDropdown({ show: true, value: link, data: data.data });
        }
    }

    const setAttorneyData = ( data ) => {
        setForm({
            ...form,
            personInCharge: data._id,
            personInChargeText: `${data.firstName} ${data.lastName} ${data.documentType} ${data.document} TP: ${data.professionalCard}`,
        })
        setDropdown({ show: false, value: '', data: [] });
    }

    const setLegalCaseData = ( data ) => {
        setForm({
            ...form,
            legalCaseID: data._id,
            legalCaseText: `${data.filingNumber}`,
        })
        setDropdown({ show: false, value: '', data: [] });
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar todos los datos para continuar",
            });
            return;
        } else {
            dispatch( createTask( form, createFunction, user.token ) );
        }
    }

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( form[field] === '' ) {
                    return true
                }
            }
        }
        return false
    }

    const createFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            navigate(currentLink)
            //console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Tarea creada con éxito"
            });
        }
    }

    useEffect(() => {
        //console.log(form)
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Nueva tarea</h1>
                <form onSubmit={handleOnSubmit}>
                    <div className="d-flex w-100 flex-wrap">
                        <div className="d-flex flex-column w-3 field position-relative">
                            <label className="label-field" htmlFor="legalCase">Caso jurídico</label>
                            <input id="legal-case" name="legalCaseText" type="text" autoComplete='off' className="input-field" placeholder="Buscar por número de radicado" onChange={(e)=>handleSearchChange(1,e)} value={form.legalCaseText}></input>
                            <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'legal-case') ? "active" : ""}`}>
                                { dropdown.data.length > 0 ?
                                    dropdown.data.map((caseItem, index) => (
                                        <div key={index} className="dropdown-item-container" onClick={() => setLegalCaseData(caseItem)}>{caseItem.filingNumber}</div>
                                    ))
                                :
                                    <span className="dropdown-message-item">Sin resultados  
                                        { user.userType === 'Administrador'?<a target="_blank" rel="noreferrer" href={"/casos/nuevo"}>, ¿crear?</a> : null}                        
                                    </span>
                                }
                            </div>
                        </div>
                        <div className="d-flex flex-column w-3 field position-relative">
                            <label className="label-field" htmlFor="attorney">Responsable</label>
                            <input id="user" name="personInChargeText" type="text" autoComplete='off' className="input-field"  placeholder="Buscar por nombres, apellidos o documento" onChange={(e)=>handleSearchChange(2,e)} value={form.personInChargeText}></input>
                            <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'user') ? "active" : ""}`}>
                                { dropdown.data.length > 0 ?
                                    dropdown.data.map((option, index) => (
                                        <div key={index} className="dropdown-item-container" onClick={() => setAttorneyData(option)}>{option.firstName} {option.lastName} {option.documentType} {option.document} TP: {option.professionalCard}</div>
                                    ))
                                :
                                    <span className="dropdown-message-item">Sin resultados  
                                        { user.userType === 'Administrador'?<a target="_blank" rel="noreferrer" href={"/usuarios/nuevo"}>, ¿crear?</a> : null}                        
                                    </span>
                                }
                            </div>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field">Fecha de cumplimiento</label>
                            <DatePicker
                                value={ form.date }
                                dayAriaLabel={"Día"}
                                dayPlaceholder={"dd"}
                                monthAriaLabel={"Mes"}
                                monthPlaceholder={"mm"}
                                yearAriaLabel={"Año"}
                                yearPlaceholder={"yyyy"}
                                name={"date"}
                                onChange={ (date)=>handleDateChange( 'date', date ) }
                                dateFormat="MM/dd/yyyy"
                            />
                        </div>
                        <div className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor="task">Actividad&#47;Tarea</label>
                            <textarea id={'task'} name={'task'} autoComplete="off" rows={2} cols={5} className="input-field" maxLength={250} type="text" onChange={handleInputChange}></textarea>
                        </div>
                        <div className="w-100 d-flex d-flex justify-content-center my-4">
                            <button className="primary-button save-button" type="submit">Guardar &#43;</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateTask;
  